module.exports = __webpack_public_path__ + "static/media/social_icon_instagram.0b8afb2d.svg";